import React, { useState } from 'react';
import { Button, Flex, notification } from '@duxton-web/ui';

import ServiceSelectionModal from '@/features/variable-complexity-policy/components/ServiceSelectionModal';
import {
  useBackfillVariableComplexity,
  useGetVariableComplexityServices,
} from '@/hooks/usePlannerQueries';

const VariableComplexityTab: React.FC = () => {
  const { refetch: fetchServices, isFetching: isFetchingServices } =
    useGetVariableComplexityServices();
  const { mutateAsync: backfill, isPending: isBackfilling } =
    useBackfillVariableComplexity();

  const [modalOpen, setModalOpen] = useState(false);
  const [services, setServices] = useState<string[]>([]);

  const handleBackfillClick = async () => {
    try {
      const { data } = await fetchServices();
      setServices(data?.services ?? []);
      setModalOpen(true);
    } catch (err) {
      notification.error({
        message: 'Failed to fetch services',
        description:
          err instanceof Error ? err.message : 'Unexpected error happened.',
      });
    }
  };

  const handleModalOk = async (skipServices: string[]) => {
    try {
      await backfill(
        skipServices.length > 0 ? { skip_services: skipServices } : undefined,
      );
      notification.success({
        message: 'Variable complexity backfill triggered successfully',
      });
      setModalOpen(false);
    } catch (err) {
      notification.error({
        message: 'Failed to trigger backfill',
        description:
          err instanceof Error ? err.message : 'Unexpected error happened.',
      });
    }
  };

  return (
    <>
      <Flex justify="flex-start">
        <Button
          type="primary"
          size="small"
          loading={isFetchingServices}
          onClick={handleBackfillClick}
        >
          Backfill
        </Button>
      </Flex>

      <ServiceSelectionModal
        open={modalOpen}
        title="Select Services to Backfill"
        services={services}
        confirmLoading={isBackfilling}
        onCancel={() => setModalOpen(false)}
        onOk={handleModalOk}
      />
    </>
  );
};

export default VariableComplexityTab;
